import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Card, Button, Tooltip, Flex } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

import { Text } from 'theme/typography';
import { TYPOGRAPHY_SIZES, COLORS } from 'theme';

interface ViewOptionsProps {
  isBlinded: boolean;
  onBlindedChange: (isBlinded: boolean) => void;
}

const ViewOptions: React.FC<ViewOptionsProps> = ({ isBlinded, onBlindedChange }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleBlindedToggle = () => {
    const newBlindedState = !isBlinded;

    // Update URL params
    const params = new URLSearchParams(searchParams);
    if (newBlindedState) {
      params.set('blinded', 'true');
    } else {
      params.delete('blinded');
    }
    setSearchParams(params, { replace: true });

    // Update parent state
    onBlindedChange(newBlindedState);
  };

  return (
    <Card
      style={{
        marginBottom: 16,
        backgroundColor: '#fafafa',
        borderColor: '#e8e8e8',
      }}
      size="small"
    >
      <Flex justify="space-between" align="center">
        <div>
          <Text size={TYPOGRAPHY_SIZES.NORMAL} weight={600}>
            Display Options
          </Text>
          <div style={{ marginTop: 4 }}>
            <Text size={TYPOGRAPHY_SIZES.SMALL} style={{ color: COLORS.lightDark }}>
              Control how segmentations are presented for review
            </Text>
          </div>
        </div>

        <Tooltip title="Shuffle segmentation positions for unbiased review">
          <Button
            type={isBlinded ? 'primary' : 'default'}
            onClick={handleBlindedToggle}
            icon={isBlinded ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          >
            {isBlinded ? 'Blinded View' : 'Standard View'}
          </Button>
        </Tooltip>
      </Flex>
    </Card>
  );
};

export default ViewOptions;
